<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  import { TiLocalStorage, USER } from '$lib/utils/storage';

  import User from './user.svelte';

  let isLogin = false;
  let username = '未知用户';

  onMount(() => {
    const storeUser = TiLocalStorage.getJson(USER);

    if (storeUser) {
      isLogin = true;
      username = storeUser.nickname || storeUser.username;
    }
  });
</script>

<div class="flex items-center justify-end sm:justify-between px-8 py-2 border-gray-200 border-b text-sm bg-gray-50" transition:fade>
  <span class="hidden sm:inline-block">欢迎来到白溪基金，祝您投资顺利！</span>

  <!-- Login button -->
  <div>
    {#if isLogin}
      <User {username} />
    {:else}
      <a href="/auth/login" class="font-medium text-orange-500 hover:text-orange-400">登录</a>
      <a href="/auth/register" class="ml-4 text-gray-500 hover:text-gray-900">新用户注册</a>
    {/if}
  </div>
</div>
